import { randomUUID } from '@/shared/utils/id';
import { StorageService, StorageTypeProps } from './classes/StorageService.class';

export const getUUID = (key: string) => {
  const storage = new StorageService(StorageTypeProps.LocalStorage);
  let uuid: string | null = storage.get(key);
  if (uuid === null) storage.set(key, (uuid = randomUUID()), 365 * 24 * 60 * 60 * 1000);
  return uuid;
};
